import { render, staticRenderFns } from "./info.vue?vue&type=template&id=35ac29a1&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=35ac29a1&scoped=true&lang=css"
import style1 from "./info.vue?vue&type=style&index=1&id=35ac29a1&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac29a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ac29a1')) {
      api.createRecord('35ac29a1', component.options)
    } else {
      api.reload('35ac29a1', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=35ac29a1&scoped=true", function () {
      api.rerender('35ac29a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/sector/info.vue"
export default component.exports